var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 3.16667C7.33317 3.53486 7.63165 3.83333 7.99984 3.83333C8.36803 3.83333 8.6665 3.53486 8.6665 3.16667C8.6665 2.79848 8.36803 2.5 7.99984 2.5C7.63165 2.5 7.33317 2.79848 7.33317 3.16667Z",
    fill: "#00529C",
    stroke: "#00529C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 8.49992C7.33317 8.86811 7.63165 9.16659 7.99984 9.16659C8.36803 9.16659 8.6665 8.86811 8.6665 8.49992C8.6665 8.13173 8.36803 7.83325 7.99984 7.83325C7.63165 7.83325 7.33317 8.13173 7.33317 8.49992Z",
    fill: "#00529C",
    stroke: "#00529C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 13.8334C7.33317 14.2016 7.63165 14.5001 7.99984 14.5001C8.36803 14.5001 8.6665 14.2016 8.6665 13.8334C8.6665 13.4652 8.36803 13.1667 7.99984 13.1667C7.63165 13.1667 7.33317 13.4652 7.33317 13.8334Z",
    fill: "#00529C",
    stroke: "#00529C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.93f10976c751f592058c72e2b3c6b21c.svg";
export { ForwardRef as ReactComponent };